import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Calendar, Users, MessageCircle, User, Target } from "lucide-react";
import { useAuth } from "../App";
import FloatingAIButton from "./FloatingAIButton";

const MobileLayout = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();
  
  const navItems = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/pou", icon: Target, label: "My Taha" },
    { path: "/classes", icon: Calendar, label: "Classes" },
    { path: "/community", icon: Users, label: "Tribe" },
    { path: "/messages", icon: MessageCircle, label: "DMs" },
    { path: "/profile", icon: User, label: "Profile" },
  ];

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      {/* Main content area */}
      <main className="pb-24">
        {children}
      </main>

      {/* Floating AI Button */}
      <FloatingAIButton />
      
      {/* Global Footer */}
      <div className="fixed bottom-20 left-0 right-0 text-center py-2 bg-[#F9F9F7]/80 backdrop-blur-sm z-40">
        <p className="text-[10px] text-[#8FA39B] tracking-wide">
          Fitness is the vehicle, Hauora is the goal.
        </p>
      </div>
      
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-[#0B3D2E]/5" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }} data-testid="bottom-navigation">
        <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                className={`flex flex-col items-center justify-center px-3 py-2 rounded-xl transition-all ${
                  isActive 
                    ? "text-[#0B3D2E]" 
                    : "text-[#8FA39B] hover:text-[#0B3D2E]"
                }`}
              >
                <Icon 
                  size={20} 
                  strokeWidth={isActive ? 2.5 : 2}
                  className="mb-0.5"
                />
                <span className="text-[10px] font-medium">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default MobileLayout;
